export class  ChangePasswordModel 
{
    OldPassword     : string;
    NewPassword     : string;
}


// WEBPACK FOOTER //
// ./src/app/models/changepasswordmodel.ts